/** 支付接入权限码。与 admin-service 的 PaymentAccessPermissions 保持一致。 */
export const PAYMENT_ACCESS_READ = 'admin:payment-access:read';
export const PAYMENT_ACCESS_WRITE = 'admin:payment-access:write';
export const PAYMENT_CREDENTIAL_WRITE = 'admin:payment-credential:write';
export const PAYMENT_TEST_ACCESS_WRITE = 'admin:payment-test-access:write';
